// /src/utils/utils.js

export function numberToThaiCurrency(num) {
  if (num === null || num === undefined) return "";

  const cleanNum = String(num).replace(/,/g, "");

  if (isNaN(cleanNum)) return "";

  const thaiNum = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
  const thaiDigit = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

  let number = parseFloat(cleanNum).toFixed(2);
  let [integerPart, decimalPart] = number.split(".");

  let bahtText = convertToThaiText(integerPart);
  let satangText = convertToThaiText(decimalPart);

  let result = "";
  if (parseInt(integerPart) > 0) {
    result += bahtText + "บาท";
  }

  if (parseInt(decimalPart) > 0) {
    result += satangText + "สตางค์";
  } else {
    result += "ถ้วน";
  }

  return result;

  function convertToThaiText(numStr) {
    let text = "";
    let len = numStr.length;
    for (let i = 0; i < len; i++) {
      let digit = parseInt(numStr.charAt(i));
      if (digit !== 0) {
        if (i === len - 1 && digit === 1 && len > 1) {
          text += "เอ็ด";
        } else if (i === len - 2 && digit === 2) {
          text += "ยี่";
        } else if (i === len - 2 && digit === 1) {
          text += "";
        } else {
          text += thaiNum[digit];
        }
        text += thaiDigit[len - i - 1];
      }
    }
    return text;
  }
}

export const parseBankAccountCustomerBill = (raw, companyCode) => {
  const s = String(raw || "").trim();
  if (!s) {
    return {
      bankName: "",
      accountName: "",
      accountNo: "",
    };
  }

  const parts = s
    .split("/")
    .map((x) => x.trim())
    .filter(Boolean);

  // ต้องมีอย่างน้อย 3 ส่วน
  if (parts.length < 3) {
    return {
      bankName: "",
      accountName: parts[0] || "",
      accountNo: parts[1] || "",
    };
  }

  // ST: AccountName / BankName / AccountNo
  if (companyCode === "ST") {
    return {
      accountName: parts[0],
      bankName: parts[1],
      accountNo: parts[2],
    };
  }

  // Non-ST: BankName / AccountName / AccountNo
  return {
    bankName: parts[0],
    accountName: parts[1],
    accountNo: parts[2],
  };
};
